<template>
    <b-toast id="toast-voucher-free-photos" variant="light" :auto-hide-delay="120000" :visible="freePhotosCount - photosInCartCount > 0">
        <div class="d-flex align-items-center">
            <h1 class="mx-4"> &#127873; </h1>
            <div class="text-left">
                <h4 class="font-weight-bolder">
                  {{ $t('toast_voucher_free_photos.title') }}
                </h4>
                <p>
                  {{ $tc('toast_voucher_free_photos.text', freePhotosCount, { count: freePhotosCount }) }}
                </p>
            </div>
        </div>
        <div class="d-flex mt-2 justify-content-center">
            <b-button variant="dark" class="ml-2" size="sm" @click="$bvToast.hide('toast-voucher-free-photos')">
                {{ $t('toast_voucher_free_photos.btn_cancel') }}
            </b-button>
            <b-button variant="primary" class="ml-2" size="sm" @click="$bvToast.hide('toast-voucher-free-photos')">
                {{ $t('toast_voucher_free_photos.btn_ok') }}
            </b-button>
        </div>
    </b-toast>
</template>


<script>
    export default {
        props: [
            'freePhotosCount',
            'photosInCartCount'
        ],
        data() {
            return {
                code: '',
                isInvalid: false
            }
        },

        methods: {
            hide() {
                this.isInvalid = false
                this.$bvToast.hide('toast-voucher')
            },

            openModalVoucher() {
                this.$bvToast.hide('toast-voucher')
                this.$bvModal.show('modal-voucher')
            }
        }
    }
</script>
